import Image1 from "../assets/konnexions_logo_2.png";
import Image2 from "../assets/Optix_logo_2.png";
import Image3 from "../assets/About_Illustration.png";
import Image4 from "../assets/Event_Breakdown_1.png"
import Image5 from "../assets/Event_Breakdown_2.png"

export const Dataofpage = [
  {
    img: Image1,
    heading: "Konnexions",
    para: `<p><b>Konnexions</b> is an IT and Web Development society dedicated to providing young Devs quality training and practical guidance.It provides a platform for young dreamers to explore a plethora of opportunities through projects,events and Hackathons that pave a way to solve complex real world problems.We strive to enhance their skillsets and keep them at the forefront of the latest tech and management practices to produce tomorrow's industry leaders.</p>`,
  },
  {
    img: Image2,
    heading: "Optix",
    para: `<p><b>OPTIX CLUB</b> is a student-driven academic club of KIIT SCHOOL OF MANAGEMENT, that is dedicated to creating a plethora of opportunities for students to enhance their knowledge, understanding in the field of Operations, Business Analytics and Information Technology.The club conducts different intra-college competitions which have some learning about the domain and helps to create interests in the classroom topics.</p>`,
  },
  {
    img: Image3,
    heading: "About Data Visualization",
    para: `<p>Visualizing data with maps or graphs helps us understand what it means by putting it in a visual context. It helps tell stories by putting data in an easy-to-understand format and drawing attention to trends and outliers. Visualization helps a student pay attention because it keeps the audience’s attention on the subject. It helps the reader learn things quickly, get better ideas, and make decisions more quickly. It gives users an easy way to share information and gives them more chances to share their ideas with everyone working on the project. </p> <br><p>A software tool to be used: <b>Excel</b> </p>`,
  },
  {
    img: '',
    heading: " EVENT BREAKDOWN",
    para: "",
  },
  {
    img: Image4,
    heading: "",
    para: `<p><h3 style="color:#0B476E;">ROUND 1:- 7th January:</h3><br>The first round will be an <b>elimination quiz round</b> with a live ranking. One participant from each group will have to attend the quiz. The quiz will have a time limit of 30 minutes. Students will be shared a link through which they will log in to a portal and appear for the test. The quiz winners will be provided with data for the final round on 14th January.</p>`,
  },
  {
    img: Image5,
    heading: "",
    para: `<p><h3 style="color:#0B476E;">ROUND 2:- 14th January:</h3><br>This will be the final round of DataViz, where the participants will have to <b>visualize the data</b> provided for the second round. The data visualization will be done in Excel. Each team or individual will get 10 minutes to explain their visualization, and 5 minutes will be dedicated to questioning. Afterward, the judges will review the work done by the participants and declare the final winner and runners-up of DataViz.</p>`,
  },
  {
    img: '',
    heading: "ORGANIZING COMMITTEE",
    para: "",
  },
];
